import React, { useState, useEffect, Fragment } from "react";
import { Popover } from "@headlessui/react";
import { StaticQuery, graphql, Link } from "gatsby";
import MenuItemDropdown from "./MenuItemDropdown";
import ContactFormModal from "./ContactFormModal";
import Logo from "./logo-svg";
import Button from "./atoms/Button";

import { PhoneCall, X } from "react-feather";
import { ArrowRight, BadgeCheck, ChevronRight, ChevronUp, ListOrdered, Menu, Phone, PhoneIcon, Target, TimerReset, TrendingUp, Users2 } from "lucide-react";
import USAFlag from "../assets/icons/usa-flag";
import siteConfig from "../siteConfig";
export const USAICON = USAFlag;


export const featureList = [
  {
    item: (
      <>
        Family Owned
        <span className="hidden md:inline"> & Operated</span>
      </>
    ),
    icon: Users2,
  },
  {
    item: (
      <>
        Licensed & Insured 
      </>
    ),
    icon: BadgeCheck,
  },
  {
    item: (
      <>
        Free Estimates
      </>
    ),
    icon: ListOrdered,
  },
]


function Navbar({ headerTransparent = false, shadow = true }) {
  const companyname = "Roach Home Improvement";
  const slogan = "#1 Roofing Experts Serving Michigan";
  const subtagline = "20+ years of serving communities";
  // Header shows the main company line on every page, including city pages.
  const phonenumber = siteConfig.phone;
  const phoneHref = `tel:${siteConfig.phoneE164(phonenumber)}`;
  const mainnavigationstyle = "inline";

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [contactFormOpen, setContactFormOpen] = useState(false);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add("menu-expanded");
    }

    return function cleanup() {
      document.body.classList.remove("menu-expanded");
    };
  }, [mobileMenuOpen]);

  const MenuItem = ({ item, source, headerTransparent }) => {
    let itemId = item.id;
    let title = item.name;
    let slug = item.url;

    if (item.submenu && item.submenu.length > 0) {
      return (
        <MenuItemDropdown item={item} label={title} type={1} source={source} headerTransparent={headerTransparent} />
      );
    }
    return (
      <Link
        to={`${slug && slug.length < 2 ? "/" : slug}`}
        activeClassName=" text-brand-600"
        className={`${
          source && source == "mobilemenu"
            ? "text-neutral-200 hover:text-white  block py-4 px-8 border-b border-white/20"
            : `p-3 py-7 border-transparent     ${
                headerTransparent
                  ? "text-neutral-600 hover:text-neutral-900 "
                  : "text-neutral-200 hover:text-white    "
              }`
        }  font-semibold text-[15px] font-display text-base  transition-colors duration-150 ease-in md:border-b-[3px] md:border-transparent
        

        relative after:bg-brand-600 after:absolute after:h-[3px] after:w-0 after:bottom-[-3px] after:left-0 hover:after:w-full after:transition-all after:duration-300 cursor-pointer
        
        
        `}
 
      >
        {item.name}
      </Link>
    );
  };

  

  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQueryInNav {
          site {
            siteMetadata {
              title
              description
              companyInfo {
                phone
                email
                addressLine1
                addressLine2
                city
                state
                zip
                license
              }
            }
          }
          allContentfulNavigation(filter: { name: { eq: "Main Navigation" } }) {
            edges {
              node {
                id
                name
                menuItems {
                  id
                  name
                  title
                  url
                  openInNewWindow
                  submenu {
                    id
                    name
                    menuItems {
                      id
                      name
                      title
                      url
                      openInNewWindow
                    }
                  }
                }
                campaign
              }
            }
          }
        }
      `}
      render={(data) => {
        const items = data.allContentfulNavigation.edges[0].node.menuItems;
        return (
          <>
         
         <div className={` items-center ${" bg-222 block text-white"}  font-display  block relative z-20`}>
                <div className="flex justify-center md:justify-between items-center  font-display mx-auto py-2 text-xs md:text-sm max-w-7xl px-4 md:px-6">
                  <span className="block text-center md:text-left font-medium">#1 Roofing Experts Serving Michigan</span>
                  <span className=" hidden md:flex items-center text-center md:text-left font-medium">
                    
                    <USAICON/>{subtagline}</span>
                </div>
              </div>
            <div className={`sticky top-0 z-[20]   border-gray-800 ${headerTransparent ? "header--transparent-main" : ""}`}>
            
              <div
                className={`${headerTransparent ? " bg-white/80 backdrop-blur-lg -mb-[95px]  " : "bg-[#2b2b2b]"} ${
                  !shadow ? "" : "md:shadow-sm nav-shadow"
                } relative z-20 `}
              >
                <div className="flex justify-between items-center px-4 md:px-6  md:space-x-10 mx-auto max-w-7xl max-h-[94px] ">
                <div className="flex items-center logo-navbar-dark py-5 relative"> 
                
                  <Link to="/" className="block  -mx-2 -my-1 w-40 md:w-48 shrink-0" title={companyname}>
                    <Logo classes={"transition text-white"} singleColor={true} />
                  </Link>
                  </div>

                  {mainnavigationstyle == "inline" ? (
                    <div className="items-center font-display md:space-x-4 hidden lg:flex">
                      {items.map((item, i) => {
                        return (
                          <MenuItem key={item.id} item={item} type={item.type} headerTransparent={headerTransparent} />
                        );
                      })}
                    </div>
                  ) : null}

                  <div className="flex-1"/>

                  {mainnavigationstyle == "stacked" ? (
                    <div className="hidden lg:block font-display text-center">
                      <span className="font-semibold block">{slogan}</span>
                      <span className="text-sm text-neutral-800 block">{subtagline}</span>
                    </div>
                  ) : null}

                 <div className="flex space-x-1 md:space-x-2 items-center md:border-l border-neutral-600"> 
                 <div className="  font-display shrink-0">
                    <div className="flex flex-col sm:flex-row items-center">
                    <a
                          className={`mr-2 hidden md:block border-inset active:scale-[.97] transition px-4 py-3 md:py-3 md:px-6 text-sm  font-semibold text-sm rounded-lg ${
                            headerTransparent ? "text-neutral-900" : "text-neutral-900"
                          }`}
                          href={phoneHref}
                        ><div className="flex items-center text-neutral-400">Call us today!</div>
                        <span className="text-lg lg:text-xl font-semibold text-white">{phonenumber}</span>
                        </a>
                      <div className="flex">
                      <Button
                          onClick={() => setContactFormOpen(true)}
                          aria-label="Open contact form"
                          className="hidden sm:block md:hidden xl:px-12 xl:py-4 mr-2 !bg-neutral-900"
 color="dark"
 >
                        <span className="text-[13px] lg:text-[15px] sm:text-sm font-medium hidden">Call</span> <PhoneIcon fill="white" className="h-4 w-4 sm:w-4 sm:h-4 ml-1"/>
                        </Button>
                        <Button
                          onClick={() => setContactFormOpen(true)}
                          className="xl:px-12 xl:py-4"
 color="brandGradient"
 >
                        <span className="text-[13px] lg:text-[15px] sm:text-sm font-medium">Free Estimate</span> <ChevronRight className="h-4 w-4 sm:w-4 sm:h-4"/>
                        </Button>
                       
                        <ContactFormModal modalOpen={contactFormOpen} onModalClose={setContactFormOpen} />
                      </div>
                    </div>
                  </div>

                  <div className={`   -my-2 lg:hidden sm:pl-0 sm:m-0`}>

                  <Popover className="lg:hidden flex">
                {({ open }) => (
                  <>
                    <Popover.Button
                    className={`${
                      headerTransparent
                        ? "text-neutral-600"
                        : " text-neutral-100 hover:bg-neutral-800  focus:text-neutral-100  focus:bg-neutral-800"
                    } text-center p-2   rounded-lg  focus:outline-none  transition duration-150 ease-in  bg-black/20`}  aria-label="Toggle site navigation"
                    >
                      {({ open }) =>

open ? (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-7 w-7 mx-auto"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
) : (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-7 w-7 mx-auto"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5" />
  </svg>
)

                     
                      }
                    </Popover.Button>
                    {/* Always mounted; open/close is a pure CSS fade + 24px
                        slide (the same motion framer-motion's AnimatePresence
                        provided). visibility is in the transition list so the
                        panel stays visible through the fade-out, then leaves
                        the a11y tree and tab order once hidden. */}
                    <Popover.Panel
                      static
                      className={`absolute inset-x-0 top-[100%] z-0 origin-top rounded-b-2xl transition-[opacity,transform,visibility] duration-200 ${
                        open
                          ? "visible opacity-100 translate-y-0 ease-out pointer-events-auto"
                          : "invisible opacity-0 -translate-y-6 ease-in pointer-events-none"
                      }`}
                    >
                        <div className="flex h-full flex-col overflow-y-scroll bg-[#2b2b2b]/95 backdrop-blur-xl shadow-xl">
                          <div className="relative  font-display">
                            <div className="flex px-6 justify-between py-2  shadow-xl relative ">
                              <p className="text-white">Call Us Today!</p>
                              <a
                                className={`block font-bold  block text-brand-600 `}
                                href={phoneHref}
                              >
                                {phonenumber}
                              </a>
                            </div>
                            {" "}
                            <div className="overflow-auto max-h-[60dvh]">
                              {items.map((item, i) => {
                                return <MenuItem key={i} item={item} type={item.type} source={"mobilemenu"} />;
                              })}
                            </div>
                          </div>
                        </div>
                      </Popover.Panel>
                  </>
                )}
              </Popover>


                 
                  </div>
                  </div></div>
 
              </div>

              {mainnavigationstyle == "stacked" ? (
                <div className="relative bg-white text-white md:shadow-sm md:border-none z-10 hidden md:block font-display">
                  <div className="flex items-center px-4 md:px-6 md:space-x-10 container mx-auto ">
                    {items.map((item, i) => {
                      return <MenuItem key={i} item={item} type={item.type} />;
                    })}
                  </div>
                </div>
              ) : null}
            </div>

            
            
            <div className="hidden bg-brand-700  text-neutral-100">
        {featureList && (
          <div className="mx-auto flex  items-center justify-center gap-3 py-3 md:gap-5">
            {featureList.map((item, i) => {
              return (
                <>
                  {" "}
                  {i > 0 && <span className="text-white">/</span>}
                  <div className="flex  flex-row  items-center" key={i}>
                    {item.icon && (
                      <item.icon
                        className="white-600 mr-2 hidden shrink-0 text-white sm:block"
                        size={16}
                      />
                    )}

                    <p className="text-left  text-xs sm:text-sm font-medium leading-6 text-white  ">
                      {item.item}
                    </p>
                  </div>
                </>
              )
            })}
          </div>
        )}
      </div>
      
  
          </>
        );
      }}
    />
  );
}

export default Navbar;
